module.exports = __webpack_public_path__ + "static/media/angry.5cf827db.svg";